import React, { useState } from 'react';
import theme from './BuyerMassInviteUpload.module.scss';
import { FileUpload, LoadingIndicator } from '@ygtechnologies/bygr-frontend-component-library';
import { ExternalLinkButton } from '@/components/Buttons';
import { getBuyerImportTemplateUrl, parseBuyerImportExcel, ParsedBuyerImportRow } from '@/services/projects';
import { faDownload } from '@fortawesome/pro-light-svg-icons';
import { Trans } from '@lingui/react/macro';
import { FileData } from '@ygtechnologies/rubus-frontend-utilities';
import { Button } from '@ygtechnologies/rubus-ui';

interface BuyerMassInviteUploadProps {
    projectId: number;
    onDataReceived(data: ParsedBuyerImportRow[]): void;
}

const BuyerMassInviteUpload: React.FC<BuyerMassInviteUploadProps> = ({ onDataReceived, projectId }) => {
    const [isLoading, setIsLoading] = useState(false);
    const [hasParseError, setHasParseError] = useState(false);
    const handleDrop = async (files) => {
        setIsLoading(true);
        setHasParseError(false);

        try {
            var result = await parseBuyerImportExcel(projectId, new FileData(files[0]));

            setIsLoading(false);

            onDataReceived(result);
        } catch (e: any) {
            setHasParseError(true);
            setIsLoading(false);
        }
    };

    if (isLoading) {
        return <LoadingIndicator />;
    }

    return (
        <div>
            <React.Fragment>
                {hasParseError && (
                    <div className={theme.errorMessage}>
                        <Trans>
                            Error parsing data, please check that the copied data is in the correct format and try again.
                        </Trans>
                    </div>
                )}

                <Button as="a" href={getBuyerImportTemplateUrl(projectId)} icon={faDownload} variant="tertiary">
                    <Trans>Download import template</Trans>
                </Button>

                {/* <Button color="tertiary" onClick={(e) => onDataReceived([])}>
                    <Trans>Manual data entry</Trans>
                </Button> */}

                <hr />

                <div>
                    <FileUpload single onDrop={handleDrop} />
                </div>
            </React.Fragment>
        </div>
    );
};

export default BuyerMassInviteUpload;
